<template>
    <div>
        <a-spin :spinning="isloading" tip="加载中...">
            <div class="select-box">
                <div class="search-line">
                    <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                        <a-row :gutter="24">
                            <a-col :span="8" :style="{ textAlign: 'left' }">
                                <a-form-item label="课件名称">
                                    <a-input v-model="where.name" placeholder="请输入要查找的课件名称" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12" :style="{ textAlign: 'left',paddingTop:'4px' }">
                                <a-button type="primary" @click="searchList">搜索</a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
                <div class="table-list">
                    <a-table :columns="classHour.columns" rowKey="id" :pagination="classHour.pagination"
                        :dataSource="classHour.datas" :loading="isloading" @change="onPageSelect"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                        :locale="{ emptyText: '暂无数据' }">
                        <span slot="chapter" slot-scope="chapter">
                            {{ chapter && chapter.title ? chapter.title : '暂无章节' }}
                        </span>
                        <span slot="video_source_type" slot-scope="video_source_type">
                            <span v-if="video_source_type == 0"> 文件</span>
                            <span v-else-if="video_source_type == 1"> 链接</span>
                            <span v-else-if="video_source_type == 2"> 第三方-获得场景</span>
                            <span v-else-if="video_source_type == 3"> 第三方-国开大学</span>
                            <span v-else-if="video_source_type == 4"> 第三方-爱迪科森</span>
                            <span v-else-if="video_source_type == 5"> 第三方-安徽课程</span>
                            <span v-else-if="video_source_type == 6"> 第三方-联安众课程</span>
                            <span v-else-if="video_source_type == 7"> 第三方-朗坤平台课程</span>
                            <span v-else> 其他</span>
                        </span>
                        <span slot="page_url" slot-scope="page_url,record">
                            <span v-if="record.video_source_type > 1">{{ record.page_url?record.page_url:record.videoId }}</span>
                            <span v-if="record.video_source_type == 0">{{ record.page_url?record.page_url:record.videoId }}</span>
                            <span v-else>{{ record.upload_url }}</span>
                        </span>
                    </a-table>
                </div>
                <div style="line-height: 24px;margin-top: 10px;">
                    <span>共： {{ classHour.pagination.total }}</span>

                    <span style="margin-left: 20px;">已选： {{ selectedRowKeys.length }}</span>
                </div>
                <div class="submit-box">
                    <a-button type="primary" style="margin-top: 20px;" @click="chooseDataZone">选择站点</a-button>
                </div>
            </div>
        </a-spin>
        <a-modal v-model="subsite.visible" title="选择要更新的站点，若所选站点没有授权过该课程，则课件授权自动跳过执行" width="80%" :footer="false">
            <DataZone @confirm="confirmChoose"></DataZone>
        </a-modal>
    </div>
</template>

<script>
import DataZone from "./dataZone.vue";
var that;
const columns = [
    {
        dataIndex: "chapter",
        key: "chapter",
        align: "center",
        title: "章节名称",
        scopedSlots: { customRender: "chapter" }
    },
    {
        dataIndex: "title",
        key: "title",
        align: "center",
        title: "课程名称"
    },
    {
        dataIndex: "video_source_type",
        key: "video_source_type",
        align: "center",
        title: "视频类型",
        scopedSlots: { customRender: "video_source_type" }
    },
    {
        dataIndex: "page_url",
        key: "page_url",
        align: "center",
        width: 320,
        title: "链接/ID",
        scopedSlots: { customRender: "page_url" }
    },
    {
        dataIndex: "hour_count",
        key: "hour_count",
        align: "center",
        title: "课程时长"
    },
    {
        dataIndex: "course_hour_count",
        key: "course_hour_count",
        align: "center",
        title: "学时"
    },
];
export default {

    props: {
        courseId: String,
        oldId: String,
        dataZone: String
    },
    components: {
        DataZone: DataZone
    },
    data() {
        return {
            isloading: false,
            selectedRowKeys: [],
            where: {
                name: "",
                pageSize: 10,
                pageNow: 1,
                oldId: this.oldId
            },
            classHour: {
                columns,
                datas: [],
                pagination: {
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    showTotal: function (total, range) {
                        return "共 " + total + " 条";
                    },
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                }
            },
            subsite: {
                visible: false,
            }
        };
    },
    mounted() {
        that = this;
        this.$nextTick(function () {
            that.getList();
        });
    },
    methods: {
        searchList(){
            this.where.pageNow = 1;
            this.getList();
        },
        /**
         * 选择课件ID
         * @param {*} e 
         */
        onSelectChange(e) {
            this.selectedRowKeys = e;
        },
        /**
         * 选择分页
         */
        onPageSelect(e) {
            this.where.pageNow = e.current;
            this.classHour.pagination.current = e.current;
            this.getList();
        },
        /**
         * 点击确认选择站点按钮
         */
        chooseDataZone() {
            this.subsite.visible = true;
        },
        /**
         * 确认选择选择站点
         */
        confirmChoose(query) {
            var param = Object.assign({}, query, { hourIds: that.selectedRowKeys, courseId: that.courseId });
            this.subsite.visible = false;
            this.isloading = true;
            this.$api.course.updateClassHourByParent(param).then(res => {
                that.isloading = false;
                if (res.errorCode == "0000") {
                    this.$emit("callback");
                } else {
                    this.$message.error(res.errorMsg)
                }
            });
        },
        getList() {
            this.isloading = true;
            this.$api.course.getCourseClassHourForParent(this.where).then(res => {
                that.isloading = false;
                if (res.errorCode == "0000") {
                    that.classHour.datas = res.data.records;
                    that.classHour.pagination.total = Number(res.data.total);
                }
            });
        }
    }

};
</script>
<style>
.mainWrapper {
    box-sizing: border-box !important;
}

.select-box {
    overflow-y: scroll;

    .search-line {
        height: 60px;
        border-bottom: 1px solid #e1e1e1;
    }

    .table-list {
        max-height: 440px;
        overflow-y: scroll;
    }

    .submit-box {
        height: 60px;
    }

}
</style>